// Disable cookies on R2 pages
// Read from new cookies set by new implementation of cookie banner
function disable_marketing_cookies_for_user() {
  jQuery.cookie('enable_marketing_cookies') != 'true';
}
